import { render, staticRenderFns } from "./NotificationGroup.vue?vue&type=template&id=1a525940"
import script from "./NotificationGroup.vue?vue&type=script&lang=js"
export * from "./NotificationGroup.vue?vue&type=script&lang=js"
import style0 from "./NotificationGroup.vue?vue&type=style&index=0&id=1a525940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports